import { Stack, Typography } from '@mui/material';
import LEXIS_LOGO from 'assets/images/LEXIS2_photo.png';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <Stack
            direction='row'
            justifyContent='space-between'
            alignItems='center'
            sx={{ p: '24px 16px 0px', mt: 'auto' }}>
            <Typography variant='caption'>
                Copyright &copy; {currentYear} IT4Innovations, All rights reserved
            </Typography>

            <Stack direction='row' alignItems='center' spacing={1}>
                <Typography variant='caption' sx={{ fontWeight: 'bold' }}>
                    Powered By
                </Typography>
                <a
                    href='https://www.lexis.tech/'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={LEXIS_LOGO} alt='LEXIS Logo' style={{ height: '24px', width: 'auto' }} />
                </a>
            </Stack>
        </Stack>
    );
};

export default Footer;
